export let plots = [];

//Decentrale windenergie
plots.push({
  id: 0,
  name: "Centrale op zee 1",
  sea: true,
  permanentOwnership: false,
  imageStyle: {left: "42%", bottom: "68%", width: "9.6%"},
  color: "#006994",
  marine: true,
});

plots.push({
  id: 1,
  name: "Centrale op zee 2",
  sea: true,
  permanentOwnership: false,
  imageStyle: {left: "56%", bottom: "75%", width: "9.6%"},
  color: "#006994",
  marine: true,
});

plots.push({
  id: 2,
  name: "Centrale op land 1",
  sea: false,
  permanentOwnership: false,
  imageStyle: {left: "45%", bottom: "25%", width: "9.6%"},
  color: "#eaaf49",
  marine: false,
});

plots.push({
  id: 3,
  name: "Centrale op land 2",
  sea: false,
  permanentOwnership: false,
  imageStyle: {left: "60%", bottom: "25%", width: "9.6%"},
  color: "#eaaf49",
  marine: false,
});



// WEBPACK FOOTER //
// ./src/actions/plotsArray.js